import { z } from "zod/v4";
import { ValidateInputPhoneNumber } from "@/app/infrastructures/misc/common-library/ValidateInputPhoneNumber";

export const receiverSchema = z
  .string()
  .nonempty("bookingV3.receiverName.error.required")
  .min(3, "bookingV3.receiverName.error.min");

export const receiverPhoneSchema = z
  .string()
  .nonempty("bookingV3.receiverPhone.error.required")
  .min(5, "bookingV3.receiverPhone.error.invalid")
  .refine((phone) => ValidateInputPhoneNumber(phone).success, {
    message: "bookingV3.receiverPhone.error.invalid"
  });

export const receiverAddressSchema = z
  .string()
  .nonempty("bookingV3.receiverAddress.error.required")
  .min(3, "bookingV3.receiverAddress.error.min");

export const receiverSenderSchema = z
  .object({
    addressReceiver: receiverAddressSchema,
    addressSender: receiverAddressSchema
  })
  .refine(
    (data) =>
      data.addressSender.toLowerCase() !== data.addressReceiver.toLowerCase(),
    {
      message: "bookingV3.senderAddress.error.senderRecipientMismatch",
      path: ["addressReceiver"]
    }
  );

const receiverDestinationCityValueSchema = z
  .string()
  .nonempty("bookingV3.receiverDestinationCity.error.required");

const receiverDestinationCityEmbargoSchema = z
  .boolean()
  .refine((value) => !value, {
    message: "bookingV3.receiverDestinationCity.error.embargo"
  });

const receiverDestinationCityUnavailableSchema = z
  .boolean()
  .refine((value) => !value, {
    message: "bookingV3.receiverDestinationCity.error.embargo"
  });

export const receiverDestinationCitySchema = z.object({
  destination: receiverDestinationCityValueSchema,
  embargo: receiverDestinationCityEmbargoSchema,
  unavailable: receiverDestinationCityUnavailableSchema
});

export const receiverPostalCodeSchema = z
  .string()
  .nonempty("bookingV3.receiverPostalCode.error.required");
